import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Container, SectionHeading } from "@/components/common/ui";
import { StepList } from "@/components/common/StepList";

const Cards = ({ b, id }) => (
  <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
    {b.items.map((it, i) => (
      <div key={it.title} className={`rounded-md border border-neutral-200 bg-white p-6 ${b.items.length === 3 && i === 0 ? "lg:col-span-2" : ""}`} data-testid={`${id}-card-${i}`}>
        <p className="font-mono text-[12px] text-brass-deep">{String(i + 1).padStart(2, "0")}</p>
        <p className="mt-3 text-lg font-medium text-ink">{it.title}</p>
        <p className="mt-2 text-[15px] leading-relaxed text-neutral-600">{it.body}</p>
      </div>
    ))}
  </div>
);

const Faq = ({ b, id }) => (
  <Accordion type="single" collapsible data-testid={`${id}-faq`}>
    {b.items.map(([q, a], i) => (
      <AccordionItem key={q} value={`q-${i}`}>
        <AccordionTrigger className="text-left text-[17px] font-normal hover:no-underline" data-testid={`${id}-faq-${i}`}>{q}</AccordionTrigger>
        <AccordionContent className="text-[15px] leading-relaxed text-neutral-600">{a}</AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);

/** Renders a guide's content blocks (cards | steps | faq), alternating backgrounds. */
export const GuideBlocks = ({ blocks, slug }) => blocks.map((b, i) => {
  const id = `guide-${slug}-block-${i}`;
  const split = b.type !== "cards";
  return (
    <section key={id} className={`py-16 sm:py-20 ${i % 2 ? "bg-mist" : ""}`} data-testid={id}>
      <Container className={split ? "grid gap-10 lg:grid-cols-[1fr_1.6fr]" : ""}>
        <div className={split ? "lg:sticky lg:top-24 lg:self-start" : "mb-10"}><SectionHeading eyebrow={b.eyebrow} title={b.title} /></div>
        {b.type === "cards" && <Cards b={b} id={id} />}
        {b.type === "steps" && <StepList steps={b.steps} testId={`${id}-steps`} />}
        {b.type === "faq" && <Faq b={b} id={id} />}
      </Container>
    </section>
  );
});
